(function () {
    'use strict';

    angular
        .module('garnaCabinet')
        .controller('ProjectDialogController', ProjectDialogController);

    ProjectDialogController.$inject = ['User', 'UserService', 'Message', 'Cache', '$window', '$mdDialog', '$q', '_', 'moment', '$stateParams'];

    /* @ngInject */
    function ProjectDialogController(User, UserService, Message, Cache, $window, $mdDialog, $q, _, moment, $stateParams) {
        var vm = this;
        vm.model = {
            message: '',
            items: [],
            limit: 4,
            hasMore: true,
            loading: false,
            disableScroll: false
        };
        var projectId;

        vm.isAdmin = isAdmin;
        vm.send = send;
        vm.read = read;
        vm.getItems = getItems;
        vm.isSenderClient = isSenderClient;
        vm.getSenderAvatar = getSenderAvatar;
        vm.getSenderName = getSenderName;
        vm.getReaderName = getReaderName;



        activate();

        ////////////////

        function activate() {
            projectId = UserService.getUser()['order_id'];
            var height = $window.innerHeight;
            var limit = parseInt(height / 56);
            vm.model.limit = Math.min(limit, 25);
            getItems(true);
        }

        function isAdmin() {
            return UserService.isAdmin();
        }

        function isSenderClient(item) {
            var user = Cache.get('u'+item.cuser);
            if(angular.isDefined(user) && user != null) {
                return UserService.isClient(user);
            }
            return true;
        }

        function getSenderAvatar(item) {
            var user = Cache.get('u'+item.cuser);
            if(angular.isDefined(user) && user != null) {
                return user.avatar;
            }
            return '';
        }

        function getSenderName(item) {
            var user = Cache.get('u'+item.cuser);
            if(angular.isDefined(user) && user != null) {
                return user.name;
            }
            return '';
        }

        function getReaderName(item) {
            var user = Cache.get('u'+item.muser);
            if(angular.isDefined(user) && user != null) {
                return user.name;
            }
            return '';
        }

        function send() {
            Message.save({text: vm.model.message, order_id: projectId})
                .$promise
                .then(function() {
                    vm.model.message = '';
                    getItems(true);
                });
        }

        function read(item) {
            Message.update(item)
                .$promise
                .then(function() {
                    getItems(true);
                })
        }

        function getItems(first) {
            var offset = 0;
            if (!first) {
                if (!vm.model.hasMore) {
                    return;
                }
                offset = vm.model.items.length-1;
            }
            if (vm.model.loading) {
                return;
            }
            vm.model.disableScroll = true;
            vm.model.loading = true;
            var params = {
                id: projectId,
                limit: vm.model.limit,
                offset: offset
            };

            Message.get(params)
                .$promise
                .then(function (response) {
                    return response.object;
                }, function (response) {
                    if (response.status == 404) {
                        vm.model.hasMore = false;
                    }
                    vm.model.loading = false;
                })
                .then(function (items) {
                    _.forEach(items, function(item) {
                        item.date = moment(item.ctime, 'YYYY-MM-DD HH:mm::ss').format('DD.MM.YY');
                        item.time = moment(item.ctime, 'YYYY-MM-DD HH:mm::ss').format('HH:mm');
                        item.message = item.text.toString().replace(/\n/g, '<br />');
                        item.isUnread = _.isNull(item.muser);
                        if(!item.isUnread) {
                            item.readDate = moment(item.mtime, 'YYYY-MM-DD HH:mm::ss').format('DD.MM.YY');
                            item.readTime = moment(item.mtime, 'YYYY-MM-DD HH:mm::ss').format('HH:mm');
                        }
                    });


                    var users = _.union(_.map(items, 'cuser'), _.map(items, 'muser'));
                    users = _.filter(users, function(item) {
                        return item != null;
                    });

                    var defer = $q.defer();
                    var promises = [];

                    _.forEach(users, function (userId) {
                        promises.push(_getUser(userId));
                    });

                    $q.all(promises)
                        .then(function (resolutions) {
                            vm.model.hasMore = _.size(items) == vm.model.limit;
                            if (!first) {
                                if (items.length > 0 && _.size(_.differenceBy(items, vm.model.items, 'id')) > 0) {
                                    vm.model.items = _.union(vm.model.items, _.differenceBy(items, vm.model.items, 'id'));
                                } else {
                                    vm.model.hasMore = false;
                                }
                            } else {
                                vm.model.items = items;
                            }
                            defer.resolve();
                        });

                    return defer.promise;
                })
                .then(function() {
                    vm.model.loading = false;
                    vm.model.disableScroll = false;
                });
        }

        function _getUser(userId) {
            if (angular.isDefined(Cache.get('u' + userId))) {
                return $q.resolve(Cache.get('u' + userId));
            } else {
                return User.get({userId: userId})
                    .$promise
                    .then(function (response) {
                        return response.user;
                    }, function () {
                        return null;
                    })
                    .then(function (user) {
                        if (user != null) {
                            user.avatar = UserService.getAvatar(user);
                            user.name = UserService.getName(user);
                            user.isClient = UserService.isClient(user);
                            Cache.put('u' + userId, user);
                        }
                        return user;
                    });
            }
        }

    }

})();

